import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const conditionOptions = [
  "Back Pain", "Fibromyalgia", "Knee Pain", "Arthritis",
  "Neuropathic Pain", "Migraines", "Chronic Pain",
  "Complex Regional Pain Syndrome", "Post-Surgical Pain", "Joint Pain",
  "Inflammatory Pain", "Musculoskeletal Pain"
];

const Register = ({ onRegister }) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState(""); // ✅ New field
  const [password, setPassword] = useState("");
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  const handleConditionToggle = (condition) => {
    setSelectedConditions((prev) =>
      prev.includes(condition)
        ? prev.filter((c) => c !== condition)
        : [...prev, condition]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
  
    //Require at least one condition
    if (selectedConditions.length === 0) {
      setError("Please select at least one condition.");
      return;
    }
  

    try {
      const res = await fetch("https://7efu8nno5m.execute-api.us-west-1.amazonaws.com/dev/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          password,
          username, // ✅ Send to backend
          conditions: selectedConditions,
        }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Registration failed");

      const userData = { email, username, conditions: selectedConditions };
      localStorage.setItem("user", JSON.stringify(userData));
      onRegister && onRegister(userData);
      setSuccess(true);

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "linear-gradient(to bottom, #eaf6ff, #d8eefd)",
      padding: "1rem"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "600px",
        minHeight: "500px",           
        padding: "3rem 2rem",
        backgroundColor: "white",
        borderRadius: "20px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}>

        <h2 style={{ fontSize: "1.75rem", marginBottom: "3rem", textAlign: "center" }}>Create Account</h2>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.2rem" }}>
          <input
            type="email"
            placeholder="Enter Email..."
            className="search-input"
            style={{ width: "90%", maxWidth: "500px", alignSelf: "center" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Choose Username..."
            className="search-input"
            style={{ width: "90%", maxWidth: "500px", alignSelf: "center" }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter Password..."
            className="search-input"
            style={{ width: "90%", maxWidth: "500px", alignSelf: "center" }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div>
            <label style={{ fontWeight: "600", fontSize: "1rem", display: "block", marginTop: "2rem", marginBottom: "1rem", textAlign: "center" }}>
              Select Conditions:
            </label>
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center"
            }}>
              {conditionOptions.map((condition) => (
                <button
                  key={condition}
                  type="button"
                  onClick={() => handleConditionToggle(condition)}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "999px",
                    fontSize: "0.9rem",
                    backgroundColor: selectedConditions.includes(condition) ? "#d4ebff" : "#f0f0f0",
                    border: selectedConditions.includes(condition)
                      ? "2px solid #0077cc"
                      : "1px solid #ccc",
                    color: selectedConditions.includes(condition) ? "#003d66" : "#444",
                    cursor: "pointer",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  {condition}
                </button>
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="summary-button"
            style={{ marginTop: "1rem", width: "80%", maxWidth: "300px", alignSelf: "center" }}
          >
            Register
          </button>

          {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
          {success && (
            <p style={{ color: "green", textAlign: "center" }}>
              Account created! Redirecting to database...
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Register;
